/** Форматирование для админки (только по-русски: это наш инструмент). */
export const fmtDate = (d: Date | null | undefined): string =>
  d ? new Intl.DateTimeFormat("ru-RU", { dateStyle: "short", timeStyle: "short", timeZone: "Europe/Belgrade" }).format(d) : "нет";

export const fmtUsd = (n: number): string => `$${n.toFixed(n < 1 ? 4 : 2)}`;

export const fmtInt = (n: number): string => new Intl.NumberFormat("ru-RU").format(n);

export const subscriptionLabel: Record<string, string> = {
  none: "нет",
  trialing: "пробный",
  active: "активна",
  past_due: "долг",
  paused: "пауза",
  canceled: "отменена",
};

export const salonStatusLabel: Record<string, string> = {
  onboarding: "настройка",
  active: "работает",
  paused: "пауза",
  deleted: "удаляется",
};

export const alertLabel: Record<string, string> = {
  "channel.disconnected": "Instagram отключился",
  "channel.token_expiring": "истекает доступ",
  "bot.failed": "ошибка бота",
  "usage.cap_reached": "потолок расходов",
  "paddle.conflict": "Paddle: проверить вручную",
};

export const auditLabel: Record<string, string> = {
  "admin.enter_salon": "вход в салон",
  "admin.create_salon": "создание салона",
  "admin.invite_owner": "приглашение владельца",
  "admin.billing_settings": "настройки оплаты",
  "salon.export": "выгрузка CSV",
  "salon.delete_requested": "удаление",
  "salon.restored": "восстановление",
};
